var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSymbolWindow = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 55 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.648.36H14.71C10.916.36 7.285.84 4.38 3.41 1.392 6.142.101 10.077.101 14.092v33.004c0 3.775 1.21 8.03 4.196 10.6 2.906 2.57 6.7 2.971 10.492 2.971h24.858c9.282 0 14.528-4.175 14.528-13.651V14.091C54.095 4.535 49.01.36 39.648.36Zm-30.75 16.3c0-5.62 2.422-7.548 7.91-7.548h5.972v16.944H8.9v-9.395Zm2.018 33.647C9.383 48.782 8.9 46.694 8.9 44.606v-9.717H22.78v17.024h-5.972c-2.18 0-4.277 0-5.892-1.606Zm34.463-5.46c0 5.46-2.664 7.066-7.83 7.066h-5.971V34.89h13.8v9.958Zm0-18.71H31.578V9.111h5.972c5.488 0 7.829 2.008 7.829 7.549v9.475Z",
  fill: "currentColor"
})));
export default SvgSymbolWindow;